<template>
  <div>
    <el-row class="wenzi">
      DCI登记
      <router-link to="/DCIRegistrationDelo">
        <el-button type="primary" class="btn-upd" icon="el-icon-plus">
          上传作品
        </el-button>
      </router-link>
    </el-row>

    <el-row>
      <el-tabs v-model="activeName" @tab-click="search" class="status-tabs" stretch>
        <el-tab-pane
          :name="item.value"
          v-for="item in applyTypeList"
          :key="item.value"
        >
          <span slot="label">
            <el-badge :value="item.num || 0" :max="99">
              {{ item.label }}
            </el-badge></span
          >
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row>
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline table-dci"
      >
        <el-form-item>
          <el-input
            v-model="formInline.searchValue"
            placeholder="输入作品名/称流水号/DCI登记号/著作权人进行查询"
            class="input-with-select-cc"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>

        <!-- <el-form-item v-if="activeName === 'noPay'">
          <el-button type="primary" :disabled="!canBatchPay" @click="onBatchPay">汇总支付</el-button>
        </el-form-item>

        <el-form-item v-if="activeName === 'finish'">
          <el-button type="primary" :disabled="!canBatchDownload" @click="onBatchDownload">汇总下载</el-button>
        </el-form-item> -->
      </el-form>
    </el-row>
    <el-row>
      <el-table
        :data="tableData"
        border
        class="table-dci"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column fixed prop="date" label="作品详情" width="600">
          <template slot-scope="scope">
            <div>流水号: {{ scope.row.dciWorkId }}</div>
            <div>
              {{ getLabelByValue(scope.row.workCategory, workCategoryType) }}
            </div>
            <div class="showName" @click="workInfo(scope.row)">
              {{ scope.row.workName }}
            </div>
            <div class="showApp">{{ scope.row.showApplyInfo }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="状态" width="220">
          <template slot-scope="scope">
            <div class="showStatus">
              {{
                getStatusLabel(scope.row)
              }}

              {{
                scope.row.errorReasonCn
                  ? '错误信息：(' + scope.row.errorReasonCn + ')'
                  : ''
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope" v-if="!scope.row.errorReasonCn?.includes?.('PROVIDER_SERVICE_TIMEOUT') || scope.row.feedbackStatus != 'FEEDBACK'">
            <el-button
              type="primary"
              v-if="scope.row.dciWorkStatus == 'PAYING'"
              @click="pay(scope.row)"
              >继续支付</el-button
            >
            <el-button
              type="primary"
              v-if="getIsCanPay(scope.row)"
              @click="pay(scope.row)"
              >支付并提交</el-button
            >
            <el-button
              type="primary"
              v-if="
                (scope.row.dciWorkStatus == 'NO_PAY' ||
                scope.row.dciWorkStatus == 'DCI_PRE_REG_FAIL' ||
                (scope.row.dciWorkStatus == 'PAIED' && scope.row.errorReasonCn)) &&
                (!scope.row.dciContentId)
              "
              @click="workUpdateClick(scope.row)"
              >修改</el-button
            >
            <el-button
              type="primary"
              v-if="scope.row.dciWorkStatus == 'NO_PAY'"
              @click="workDeleteClick(scope.row)"
              >删除</el-button
            >
            <el-button
              type="primary"
              v-if="(scope.row.feedbackStatus == 'FEEDBACK_PASS' || scope.row.feedbackStatus == 'NO_FEEDBACK') && scope.row.dciWorkStatus == 'DCI_PRE_REG_FAIL'"
              @click="workFeedBackClick(scope.row)"
              >申诉</el-button
            >
            <el-button
              type="primary"
              v-if="getCanDownload(scope.row)"
              @click="workFeedInfoClick(scope.row)"
              >下载</el-button
            >

            <el-button
              type="primary"
              v-if="
                ((scope.row.feedbackStatus == 'FEEDBACK_PASS' || scope.row.feedbackStatus == 'NO_FEEDBACK') && scope.row.dciWorkStatus == 'DCI_PRE_REG_FAIL') ||
                (scope.row.feedbackStatus == 'FEEDBACK_NOT_PASS' && scope.row.dciWorkStatus != 'REFUNDED') ||
                (scope.row.dciWorkStatus == 'PAIED' && scope.row.errorReasonCn)
              "
              @click="refundClick(scope.row)"
              >发起退款</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-row class="table-dci pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>

    <el-dialog title="支付提示" :visible.sync="dialogVisible" width="50%">
      <div>
        <el-result
          icon="success"
          title="成功提示"
          subTitle="付款成功后该订单下的所有产品都将运入后台审核阶段，请持续关注列表状态（也可手动刷新）。"
        >
          <template slot="extra">
            <el-button @click="dialogVisibleClick" type="primary" size="medium"
              >知道啦</el-button
            >
          </template>
        </el-result>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleClick">知道啦</el-button>
      </span> -->
    </el-dialog>
     <!-- 支付弹窗 -->
     <PaymentDialog ref="paymentDialog" />
  </div>
</template>
<script>
import PaymentDialog from '@/components/PaymentDialog.vue'
import {
  workList,
  workDelete,
  payDciWork,
  statusCount,
  getPayResult,
  doQueryDci,
  refund,
  dciWorkDownloadBatch,
  cancelDciWork,
} from '@/api/user.js'
import { downloadFileByUrl, toNumber, openPaymentWindow } from '@/utils/index'
import { PAY_TYPE } from '@/utils/constants'

export default {
  name: 'DCIRegistration',
  components: { PaymentDialog },
  mixins: [],
  props: {},
  data () {
    return {
      tableData: [
        // {
        //   totalAmount: '0.00',
        //   dciWorkId: '2025Z11L000000002',
        //   record_screen_pay_status: 'NO_PAY',
        //   workCategory: 'WORD',
        //   authorName: '诸葛亮',
        //   showApplyInfo: '我申请',
        //   monitor_pay_status: 'NO_PAY',
        //   workName: '出师表',
        //   showCode: '2025Z11L000000002',
        //   dciWorkStatus: 'NO_PAY',
        //   dciUserId: 'DUSANDBOX8250207000000697929',
        //   fileType: 'TEXT'
        // }
      ],
      workCategoryType: [
        {
          /**
           * 文字作品，支持文件类型 TEXT
           */
          value: 'WORD',
          label: '文字作品'
        },
        {
          /**
           * 口述作品，支持文件类型 AUDIO
           */
          value: 'ORAL',
          label: '口述作品'
        },
        {
          /**
           * 音乐作品，支持文件类型 AUDIO
           */
          value: 'MUSIC',
          label: '音乐作品'
        },
        {
          /**
           * 戏剧作品，支持文件类型 TEXT
           */
          value: 'DRAMA',
          label: '戏剧作品'
        },
        {
          /**
           * 曲艺作品，支持文件类型 TEXT
           */
          value: 'QUYI',
          label: '曲艺作品'
        },
        {
          /**
           * 舞蹈作品，支持文件类型 VIDEO
           */
          value: 'DANCE',
          label: '舞蹈作品'
        },
        {
          /**
           * 杂技作品，支持文件类型 VIDEO
           */
          value: 'ACROBATICS',
          label: '杂技作品'
        },
        {
          /**
           * 美术作品，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'ART',
          label: '美术作品'
        },
        {
          /**
           * 建筑作品，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'ARCHITECTURE',
          label: '建筑作品'
        },
        {
          /**
           * 摄影作品，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'PHOTOGRAPHY',
          label: '摄影作品'
        },
        {
          /**
           * 电影作品，支持文件类型 VIDEO
           */
          value: 'MOVIE',
          label: '电影作品'
        },
        {
          /**
           * 类似摄制电影方法创作的作品，支持文件类型 VIDEO
           */
          value: 'AUDIOVISUAL',
          label: '类似摄制电影方法创作的作品'
        },
        {
          /**
           * 工程设计图、产品设计图，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'DESIGN',
          label: '工程设计图、产品设计图'
        },
        {
          /**
           * 示意图，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'DIAGRAM',
          label: '示意图'
        },
        {
          /**
           * 模型，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'MODEL',
          label: '模型'
        }
      ],
      // 状态列表
      statusList: [
        { value: 'NO_PAY', label: '待支付' },
        { value: 'PAYING', label: '支付中' },
        { value: 'PAIED', label: '已支付' },
        { value: 'DCI_PRE_REG_AUDITING', label: '申领审核中' },
        { value: 'DCI_PRE_REG_FINISH', label: '申领成功' },
        { value: 'DCI_PRE_REG_FAIL', label: '申领失败' },
        // { value: 'FEEDBACK', label: '申述中' },
        // { value: 'FEEDBACK_PASS', label: '申述成功' },
        // { value: 'FEEDBACK_NOT_PASS', label: '申述失败' },
        { value: 'DCI_PRE_REG_CANCEL', label: 'dci撤销' },

        {
          value: 'DCI_PRE_REG_TOBE_CONFIRM',
          label: '审核中' //实际上 申领待确认，账户余额不足
        },
        { value: 'REFUNDED', label: '已退款' },
        { value: 'REFUNDING', label: '退款中' },
        { value: 'AMEND', label: '已补证' },
        { value: 'DCI_CANCELING', label: 'dci撤销中' }, //
      ],
      applyTypeList: [
        {
          value: 'total',
          label: '全部',
          num: 1
        },
        {
          value: 'noPay',
          label: '待支付'
        },
        {
          value: 'handing',
          label: '审核中'
        },
        {
          value: 'back',
          label: '驳回'
        },
        {
          value: 'finish',
          label: '已下证'
        },
      ],
      // 总数量
      total: 0,
      currentPage: 1,
      pageSize: 10,
      multipleSelection: [], // 表格数据
      formInline: {
        searchValue: '',
        applyType: ''
      },
      dialogVisible: false,
      activeName: 'total' // 选中的标签页
    }
  },
  created () {
    statusCount({
      dciWorkStatus: '',
      searchValue: this.formInline.searchValue,
      params: {
        beginTime: '',
        endTime: '',
        applyType: '',
        status: this.activeName
      }
    }).then(res => {
      res.data.forEach(item => {
        this.applyTypeList.forEach((applyType, index) => {
          if (item.key === applyType.value) {
            this.applyTypeList[index].num = item.count
          }
        })
      })
    })
  },
  computed: {
    canBatchPay() {
      return this.multipleSelection.some(row => this.getIsCanPay(row))
    },
    canBatchDownload() {
      return this.multipleSelection.some(row => this.getCanDownload(row))
    }
  },
  watch: {},
  async mounted () {
    await this.search()
  },
  methods: {
    getIsCanPay(row){
      return row.dciWorkStatus == 'NO_PAY' && row.authorName
    },
    dialogVisibleClick () {
      this.search()
      this.dialogVisible = false
    },
    getLabelByValue (value, works) {
      const found = works.find(work => work.value === value)
      return found ? found.label : '未找到对应的作品类型'
    },
    getStatusLabel(row){
      const statusLabel = this.getLabelByValue(row.dciWorkStatus, this.statusList)
      if(statusLabel == '待支付'){
        return '待支付: ' + row.totalAmount
      }
      if((row.feedbackStatus == 'FEEDBACK_NOT_PASS' || row.feedbackStatus == 'FEEDBACK_PASS') && row.dciWorkStatus == 'REFUNDED'){
        return '已退款'
      }
      if(row.feedbackStatus == 'FEEDBACK_NOT_PASS'){
        return '申诉失败'
      }
      if(row.feedbackStatus == 'FEEDBACK'){
        return '申诉中'
      }
      return statusLabel
    },
    getCanDownload(row){
      return ((row.feedbackStatus == 'FEEDBACK_PASS' || row.feedbackStatus == 'NO_FEEDBACK') && row.dciWorkStatus == 'DCI_PRE_REG_FINISH')
    },
    // 点击支付
    async pay (row) {
      if (row.dciWorkStatus == 'PAYING') {
        // 支付类型，DCI、DIGITAL_SERVICE、MONITOR、RECORD_SCREEN
        const res = await getPayResult({
          dciWorkId: row.dciWorkId,
          bizType: 'DCI'
        })
        if (res.code != 200) {
          return
        }
        console.log(res, 'getPayResultgetPayResult')
      }
      await this.onPaymentDialog([row])
    },
    async onPaymentDialog(rowList = []){
      if(!(rowList.length > 0)) {
        this.$message.warning('没有可用支付订单')
        return
      }      
      // 【新代码-弹窗支付】
      const amount = rowList.reduce((total, row) => {
        return total + toNumber(row.totalAmount)
      }, 0)
      this.$refs.paymentDialog.open({
        amount: amount.toFixed(2),
        rowList,
        onAlipay: this.handlePaymentAlipay.bind(this),
        onBalance: this.handlePaymentBalance.bind(this),
      })
    },
    async handlePaymentAlipay(paymentInfo){
      const { rowList = [] } = paymentInfo || {}
      const idList = rowList.map(row => row.dciWorkId)
      const res = await payDciWork(idList,{ payType: PAY_TYPE.TRANSFER })
      if (res.code == 200) {
        if (res.msg) {
          openPaymentWindow(res.msg)
        }
        this.search()
        this.dialogVisible = true
      }
    },
    // 支付弹窗 - 余额支付回调
    async handlePaymentBalance (paymentInfo) {
      const { rowList = [] } = paymentInfo || {}
      const idList = rowList.map(row => row.dciWorkId)
      const res = await payDciWork(idList,{ payType: PAY_TYPE.BALANCE })
      if (res.code == 200) {
        // TODO: 调用余额支付接口
        this.$message.success('余额支付成功')
        this.search()
      }
    },
    // 批量支付
    async onBatchPay(){
      const rowList = this.multipleSelection.filter(row => this.getIsCanPay(row))
      await this.onPaymentDialog(rowList)
    },
    // 查询列表
    async search () {
      const res = await workList(
        {
          dciWorkStatus: '',
          searchValue: this.formInline.searchValue,
          params: {
            beginTime: '',
            endTime: '',
            applyType: '',
            status: this.activeName
          }
        },
        {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          tableName: undefined,
          tableComment: undefined,
          isAsc: 'desc',
          orderByColumn: 'dw.createTime'
        }
      )
      console.log(res, 'res')
      if (res.code == 200) {
        this.tableData = res.rows

        this.total = res.total
      } else {
        this.$message.error('查询作品列表失败' + res.msg)
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.search()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.search()
    },
    // 删除作品
    workDeleteClick (row) {
      this.$confirm('此操作将永久删除该作品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        console.log(row, 'row')
        const res = await workDelete({
          dciWorkId: row.dciWorkId
        })
        if (res.code == 200) {
          this.$message.success('删除成功')
          this.search()
        } else {
          this.$message.error('删除失败' + res.msg)
        }
      }).catch(() => {})
    },
    // 修改作品
    workUpdateClick (row) {
      this.$router.push({
        path: '/DCIRegistrationDelo',
        query: { dciWorkId: row.dciWorkId }
      })
    },
    workFeedBackClick (row) {
      this.$router.push({
        path: '/DCIFeedBackSubmit',
        query: { dciWorkId: row.dciWorkId }
      })
    },
    async workFeedInfoClick (row) {
      const res = await doQueryDci({
        dciContentId: row.dciContentId,
        dciWorkStatus: row.dciWorkStatus
      })
      if (res.code == 200) {
        const url = res.data.preRegCertUrl
        // downloadFileByUrl(url, row.workName + '_证书.pdf')
        // 在新窗口中打开
        window.open(url, '_blank')
      } else {
        this.$message.error('查询作品列表失败' + res.msg)
      }
    },
    async onBatchDownload(){
      const downloadList = this.multipleSelection?.filter(row => this.getCanDownload(row)) || []
      if (!(downloadList?.length > 0)) {
        this.$message.warning('没有可下载的证书，请选择已下证且有证书的记录')
        return
      }
      try {
        const dciContentIdList = downloadList.map(row => row.dciContentId)
        const res = await dciWorkDownloadBatch(dciContentIdList)
        await downloadFileByBlob(res, '批量下载.zip')
      } catch (error) {
        this.$message.error(error.message || '下载失败')
      }
    },
    workInfo (row) {
      const fullURL = window.location.href
      const urlBeforeHash = fullURL.split('#')[0]
      let url =
        urlBeforeHash +
        `#/InfoLock?dciWorkId=${row.dciWorkId}&dciContentId=${row.dciContentId}`
      // 在新窗口中打开
      window.open(url, '_blank')
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection, 'multipleSelection')
    },
    refundClick (rows) {
      this.$confirm('退费后将结束当前业务不可恢复，是否继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 类型，DCI、DIGITAL_SERVICE、MONITOR、RECORD_SCREEN
        // 返回值是REFUNDED、REFUNDING。已退款和退款中。后面退款中的会定时任务1分钟一次的刷新，可以考虑提供单个退款状
        const res = await refund({
          dciWorkId: rows.dciWorkId,
          dciContentId: rows.dciContentId,
          bizType: 'DCI'
        })
        if (res.code == 200) {
          this.$message.success('退款成功')
          this.search()
        }
      }).catch(() => {})
    },
  }
}
</script>
<style lang="scss" scoped>
.status-tabs {
  margin: 0 50px;
  
  ::v-deep .el-tabs__header {
    margin-bottom: 15px;
  }
  
  ::v-deep .el-tabs__nav-wrap {
    overflow: visible;
  }
  
  ::v-deep .el-tabs__nav {
    width: 100%;
    display: flex;
    
    .el-tabs__item {
      flex: 1;
      text-align: center;
      padding: 0 20px;
      height: 50px;
      line-height: 50px;
    }
  }
  
  ::v-deep .el-badge {
    .el-badge__content {
      top: 10px;
      right: 5px;
    }
  }
}

.wenzi {
  height: 80px;
  margin-left: 50px;
  text-align: center;
  line-height: 80px;

  letter-spacing: normal;
  color: #333333;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}
.btn-upd {
  margin-left: 100px;
}
.table-dci {
  width: 1200px;
  margin: 0 auto;
}
.pagination {
  text-align: end;
  margin-top: 20px;
}
.showApp {
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  text-transform: none;

  // width: 294px;
  display: inline-block;
  padding: 0 5px;
  height: 25px;
  line-height: 25px;
  background: inherit;
  background-color: rgba(242, 242, 242, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(121, 121, 121, 1);
  border-radius: 5px;
  box-shadow: none;
  text-align: left;
  margin: 10px 0;
}
.showName {
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  cursor: pointer;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}
.showStatus {
  letter-spacing: normal;
  line-height: normal;
  font-size: 18px;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  color: #169bd5;
  text-align: center;
  word-wrap: break-word;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}
.input-with-select-cc {
  width: 400px;
}

.el-badge__content.is-fixed {
  top: 10px;
}
</style>
